import { Capacitor } from '@capacitor/core'
import { App as CapacitorApp } from '@capacitor/app'

import appVersionService from 'services/appVersion'
import { isVersionOutdated } from 'utils/compareVersions'

export const SET_APP_VERSION_STATUS = 'SET_APP_VERSION_STATUS'

export const setAppVersionStatus = isOutdated => ({
  type: SET_APP_VERSION_STATUS,
  isOutdated,
})

// Roda a cada login (ver App.js). Web (dev/preview no navegador) não tem uma
// versão "instalada" pra comparar, então não faz sentido nesse ambiente.
export const checkAppVersion = () => async dispatch => {
  const platform = Capacitor.getPlatform()
  if (platform !== 'android' && platform !== 'ios') return

  try {
    const [{ version: installedVersion }, response] = await Promise.all([
      CapacitorApp.getInfo(),
      appVersionService.fetchLatestVersion(platform),
    ])

    const latestVersion = response?.data?.version
    if (!latestVersion) return

    dispatch(setAppVersionStatus(isVersionOutdated(installedVersion, latestVersion)))
  } catch {
    // se o back não responder, não bloqueia o app com o alerta
  }
}
